import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
}));

export default useStyles;
